export class GADataLayer {
    public static link_click(click_url:string, source_url:string, click_id:string, click_class:string):void {
        let trackObj = {
            'event': 'link_click',
            'type': 'link_click',
            'click_url': click_url,
            'source_url': source_url,
            'click_id': click_id,
            'click_class': click_class
        };
        GADataLayer.push(trackObj);
    }
    public static push(data:any) {
        //console.log(data);
        (window as any).dataLayer = (window as any).dataLayer || [];
        (window as any).dataLayer.push(data);
    }
}